import { render, staticRenderFns } from "./GroupDisplay.vue?vue&type=template&id=33bec4e9&scoped=true&"
import script from "./GroupDisplay.vue?vue&type=script&lang=js&"
export * from "./GroupDisplay.vue?vue&type=script&lang=js&"
import style0 from "./GroupDisplay.vue?vue&type=style&index=0&id=33bec4e9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bec4e9",
  null
  
)

export default component.exports